import { defineReactiveModel, Persistable } from "vue-app-utils";
import Model from "@/models/model";
import { ordinal, rating } from "openskill";
import { ordinalToScaledDisplayRating } from "@/utils/scaled-display-rating";

const Scorecard = {
  extends: Model,
  mixins: [
    Persistable
  ],
  data () {
    return {
      mu: 25,
      sigma: 25 / 3,
      updatedAt: null
    };
  },
  computed: {
    ordinal () {
      return ordinal(rating({ mu: this.mu, sigma: this.sigma }));
    },
    scaledDisplayRating () {
      return ordinalToScaledDisplayRating(this.ordinal);
    }
  }
};

export default defineReactiveModel(Scorecard);